export const FirebaseAppName = "JustMeetApp";
